import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import en from './locales/en/perfectTruck.json';
import fr from './locales/fr/perfectTruck.json';
import es from './locales/es/perfectTruck.json';
import enHarbor from './locales/en/harbor.json';
import frHarbor from './locales/fr/harbor.json';
import esHarbor from './locales/es/harbor.json';

const LANGUAGE_KEY = 'pt_language';

const getSavedLanguage = async (): Promise<string> => {
  if (Platform.OS === 'web') {
    return localStorage.getItem(LANGUAGE_KEY) ?? 'en';
  }
  return (await AsyncStorage.getItem(LANGUAGE_KEY)) ?? 'en';
};

const initI18n = async () => {
  const savedLang = await getSavedLanguage();

  await i18n.use(initReactI18next).init({
    lng: savedLang,
    fallbackLng: 'en',
    ns: ['perfectTruck', 'harbor'],
    defaultNS: 'perfectTruck',
    resources: {
      en: { 
        perfectTruck: en,
        harbor: enHarbor,
      },
      fr: { 
        perfectTruck: fr,
        harbor: frHarbor,
      },
      es: { 
        perfectTruck: es,
        harbor: esHarbor,
      },
    },
    interpolation: { escapeValue: false },
  });
};

initI18n();

export default i18n;
